import { Button, Grid, Tooltip } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CustomAccordion from '../CustomAccordion/CustomAccordion';
import BaseResponse from '../../app/BaseResponse';
import Utility from '../../app/utility';
import { showLoading } from '../LoadingView/reducers/LoadingViewReducer';
import CareApi, { GetClassificationsParam } from '../Care/api/CareApi';
import { ClassificationSelector, setClassificationResults, setSearchDate, setTriggerSearchClassification } from './reducers/ClassificationReducer';
import ClassificationModel from './models/ClassificationModel';
import StartEndDatepicker from '../StartEndDatepicker/StartEndDatepicker';

const ClassificationSearch: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const ClassificationData = useSelector(ClassificationSelector);

    useEffect(() => {
        dispatch(showLoading(true));

        CareApi.GetClassifications({
            searchDate: ClassificationData.query.searchDate
        } as GetClassificationsParam)
            .then((response: BaseResponse<ClassificationModel[]>) => {
                if (response.success) {
                    dispatch(setClassificationResults(response.data));
                } else {
                    Utility.Alert.Error(response.message);
                }
            }).catch((error) => {
                Utility.Alert.Error(error);
            })
            .finally(() => {
                dispatch(showLoading(false));
            });
    }, [ClassificationData.triggerSearch])

    return (
        <>
            <CustomAccordion
                title="Search"
                className="Classification-search-area"
                defaultOpen={true}>
                <Grid container>
                    <Grid xs={2} className="Classification-button">
                        <Grid container>
                            <Tooltip title="Alt + W">
                                <Button
                                    fullWidth
                                    variant="contained"
                                    className="tonnage-search-save-button"
                                    onClick={() => {
                                        dispatch(setTriggerSearchClassification((new Date()).getTime()));
                                    }}
                                >
                                    RUN SEARCH (w)
                                </Button>
                            </Tooltip>
                        </Grid>
                    </Grid>
                    <Grid xs={10}>
                        <StartEndDatepicker
                            startDateLabel="Search date"
                            useQuickEndDateInput={false}
                            className="tonnage-search-item"
                            onStartDateChange={(date: string) => {
                                dispatch(setSearchDate(date));
                            }}
                            useSingleMode={true}
                            startDateValue={ClassificationData.query.searchDate}
                        >
                        </StartEndDatepicker>
                    </Grid>
                </Grid>
            </CustomAccordion>
        </>
    )
};

export default ClassificationSearch;